import bootbox from 'bootbox'
import { isObject } from 'lodash'

import './bootboxStyles.css'

type Alert = {
  (message: string, callback?: () => void): Promise<void>
  (options: BootboxAlertOptions): Promise<void>
}

export const alert: Alert = (options): Promise<void> => {
  return new Promise<void>(resolve =>
    bootbox.alert({
      buttons: {
        ok: {
          label: 'Close',
          className: 'btn-secondary'
        }
      },
      ...createBootboxOptions<void>('message', options, resolve),
      callback: resolve
    })
  )
}

type Confirm = {
  (message: string): Promise<boolean>
  (
    options: Omit<BootboxConfirmOptions, 'callback' | 'buttons'> & {
      buttons?: Partial<BootboxBaseOptions>['buttons']
    }
  ): Promise<boolean>
}

export const confirm: Confirm = (options): Promise<boolean> => {
  return new Promise<boolean>(resolve =>
    bootbox.confirm({
      ...getClassNamesForButtons(),
      ...createBootboxOptions<boolean>('message', options, resolve)
    })
  )
}

export async function prompt(options: any): Promise<string | null> {
  return new Promise<string>(resolve =>
    bootbox.prompt({
      ...getClassNamesForButtons(),
      ...createBootboxOptions<string>('title', options, resolve)
    })
  )
}

function createBootboxOptions<Result extends string | boolean | void>(
  key: string,
  options: any,
  resolve: (value: Result) => void
) {
  const newOptions = isObject(options) ? (options as any) : { [key]: options }
  newOptions.callback = resolve

  return newOptions
}

export async function dialog(options: any) {
  return new Promise(resolve =>
    // eslint-disable-next-line
    bootbox.dialog(createBootboxDialogOptions('message', options, resolve))
  )
}

function createBootboxDialogOptions<Result extends string | boolean | void>(
  key: string,
  options: any,
  resolve: (value: Result) => void
) {
  const dialogOptions = isObject(options) ? (options as any) : { [key]: options }

  dialogOptions.callback = resolve
  dialogOptions.onEscape = resolve

  if (dialogOptions.buttons) {
    Object.keys(dialogOptions.buttons).forEach(key => {
      const dialogButton = dialogOptions.buttons[key]
      dialogOptions.buttons[key] = { ...dialogButton, callback: dialogButton.callback || resolve }
    })
  }

  return dialogOptions
}

function getClassNamesForButtons() {
  return {
    buttons: {
      confirm: {
        className: 'btn-primary e2e-modal-success-button'
      },
      cancel: {
        label: 'Close',
        className: 'btn-secondary test-modal-cancel-button'
      }
    }
  }
}
